<template>
  <div>
    <nav class="bar bar-nav">
      <h1 class="title">登录</h1>
    </nav>
    <div class="content">
      <div class="list-block">
        <ul>
          <li>
            <div class="item-content">
              <div class="item-media"><i class="icon icon-form-name"></i></div>
              <div class="item-inner">
                <div class="item-title label">手机号</div>
                <div class="item-input">
                  <input type="text" v-model="mobile" placeholder="手机号">
                </div>
              </div>
            </div>
          </li>
          <li>
            <div class="item-content">
              <div class="item-media"><i class="icon icon-form-password"></i></div>
              <div class="item-inner">
                <div class="item-title label">验证码</div>
                <div class="item-input">
                  <input style="width: 70%;display: inline-block" type="text" v-model="veriCode" placeholder="验证码">
                  <div style="display: inline;width: 2.5rem">
                    <a @click="sendVeriCode" id="btn">发送</a>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="content-block">
        <div class="row">
          <div class="col-100"><a @click="submit" class="button button-big button-fill button-success">登录</a></div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  import $ from 'jquery'
//  import md5 from 'js-md5'

  export default {
    mounted () {
    },
    created () {
    },
    data () {
      return {
        mobile: '',
        veriCode: '',
        coolDown: false,
        error: ''
      }
    },
    methods: {
      sendVeriCode () {
        let _this = this
        if (!_this.coolDown) {
          _this.gcapi().then((response) => {
            _this.coolDown = true
            time(document.getElementById('btn'))
            $.toast(response.body['message'])
          }, (response) => {
            $.toast(response.body['message'])
          })
        }
        let wait = 60
        function time (o) {
          if (wait === 0) {
            _this.coolDown = false
            o.innerHTML = '发送'
            o.style.color = ''
            wait = 60
          } else {
            o.innerHTML = wait + 's'
            o.style.color = '#C8C8C8'
            wait--
            setTimeout(function () {
              time(o)
            }, 1000)
          }
        }
      },
      submit () {
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// MobileLogin.vue?008033e6